export default __webpack_public_path__ + "static/media/tecnologias.b91828d9.png";